import { PaymentItemType } from './enums/payment-item-type';
import { TransactionBalancePaymentType } from './enums/transaction-balance-payment-type';
import { PaymentLimitSettings } from './payment-limit-settings';

export class PaymentItem {
	itemType: PaymentItemType = PaymentItemType.NotSet;
	itemKey: number;
	paymentItemId: string;
	isSelected: boolean;
	merchantKey: number;
	initialAmount: number;
	enteredAmount: string;
	paymentBalanceType: TransactionBalancePaymentType = TransactionBalancePaymentType.NotSet;
	customerAccountReferenceId: string;
	customerAccountName: string;
	contactName: string;
	dueDate: string;
	paymentLimitSettings: PaymentLimitSettings = new PaymentLimitSettings();
	bucketDisplayName: string;
	portfolioKey: number;
	disabled: boolean;
	areFeesEnabled: boolean;
}